import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MessageToastService } from "@shared/services/message-toast.service";

@Component({
	selector: "app-file-drag-and-drop",
	templateUrl: "./file-drag-and-drop.component.html",
	styleUrls: ["./file-drag-and-drop.component.scss"],
	standalone: false
})
export class FileDragAndDropComponent {
	protected files: File[] = [];
	protected eventDragCounter = 0;

	@Input() multiple = true;
	@Input() accept = "";
	@Input() maxFileSizeMb = 5;
	@Output() handleUpload = new EventEmitter<File[]>();
	@Output() handleDragEnter = new EventEmitter<boolean>();

	constructor(private messageToastService: MessageToastService) {}

	emitDragEnterEvent(): void {
		if (this.eventDragCounter > 0) {
			this.handleDragEnter.emit(true);
			return;
		}
		this.handleDragEnter.emit(false);
	}

	onDragOver(event: DragEvent): void {
		event.stopPropagation();
		event.preventDefault();
	}

	onDragEnter(event: DragEvent): void {
		event.stopPropagation();
		event.preventDefault();
		this.eventDragCounter++;
		this.emitDragEnterEvent();
	}
	onDragLeave(event: DragEvent): void {
		event.stopPropagation();
		event.preventDefault();
		this.eventDragCounter--;
		this.emitDragEnterEvent();
	}

	onDropFile(event: DragEvent): void {
		event.stopPropagation();
		event.preventDefault();
		this.onChangeFiles(event);
		this.eventDragCounter = 0;
		this.emitDragEnterEvent();
	}

	onChangeFiles(event: Event | DragEvent) {
		try {
			if ("dataTransfer" in event && event.dataTransfer) {
				this.checkFilesWithSizeLimitExceed(event.dataTransfer.files);
				this.files.push(...Array.from(event.dataTransfer.files));
				this.handleUpload.emit(this.files);
				return;
			}
			const files = (<HTMLInputElement>event.target).files;
			if (files) {
				this.checkFilesWithSizeLimitExceed(files);
				this.files.push(...Array.from(files));
				this.handleUpload.emit(this.files);
			}
		} catch (error) {
			if (error instanceof Error) {
				this.messageToastService.errorDefaultToast({
					message: error.message
				});
			}
		}
	}

	private checkFilesWithSizeLimitExceed(files: FileList): void {
		if (!files || files.length <= 0) {
			return;
		}

		for (let i = 0; i < files.length; i++) {
			const fileSizeLimit: number = this.maxFileSizeMb * 1024 * 1024;
			const fileSize: number = files.item(i)?.size ?? 0;

			if (fileSize > fileSizeLimit) {
				throw new Error(
					`Tamanho máximo do arquivo para upload é de ${this.maxFileSizeMb}MB`
				);
			}
		}
	}

	eraseFileToUpload(index: number): void {
		this.files.splice(index, 1);
		this.handleUpload.emit(this.files);
	}
}
